import COLORS from '@web-ui-kit/colors'
import Icon from '@web-ui-kit/icon'
import * as Sc from './snackbar.style'

export type SnackbarTypes = 'error' | 'info' | 'success' | 'warning'
export type SnackbarSizes = 'small' | 'large'

export const snackbarColor: Record<SnackbarTypes, string> = {
  error: COLORS.ERROR_700,
  info: COLORS.INFO_700,
  success: COLORS.SUCCESS_700,
  warning: COLORS.WARNING_700,
}
export type SnackbarProps = {
  /**
   * Id for testing
   */
  dataTestId?: string
  /**
   * Id for the snackbar
   */
  id?: string
  /**
   * Snackbar size
   */
  size?: SnackbarSizes
  /**
   * A text to display
   **/
  text: string
  /**
   * Type of the snackbar
   **/
  type?: SnackbarTypes
}

const Snackbar: (props: SnackbarProps) => JSX.Element = ({
  dataTestId,
  id,
  size = 'large',
  text,
  type = 'info',
}: SnackbarProps) => {
  return (
    <Sc.Container
      $color={snackbarColor[type]}
      $size={size}
      data-testid={dataTestId}
      id={id}
      role='alert'
    >
      <Icon
        fill={type !== 'warning' ? COLORS.WHITE : COLORS.BLACK}
        height={32}
        icon={type}
        width={32}
      />
      <Sc.CustomText
        $color={type !== 'warning' ? COLORS.WHITE : COLORS.BLACK}
        variant='small'
      >
        {text}
      </Sc.CustomText>
    </Sc.Container>
  )
}

export default Snackbar
